import Vue from 'vue';
import Vuex from 'vuex';
import validation from './modules/validation.js';
import { answerService } from '@/services/answerService';
import { utilityService } from '@/services/utilityService';
import { CONSTANTS } from '@/common/constants';
import { keyBy } from 'lodash';

Vue.use(Vuex);
const survey = {
	state: {
		/** Dictionary key: qId, value: Array of answer objects */
		answers: {},
		count: 0,
		/** True if the survey is currently saving */
		isSaving: false,
		/** True if the survey question is loading matrix changes */
		isLoading: false,
		/** Holds the timestamp for the last save */
		lastSavedTimeStamp: null,
		singleanswer: {},
		standardSurvey: false,
		questionId: 0
	},
	mutations: {
		setAnswers (state, { qId, answerArray }) {
			Vue.set(state.answers, qId, answerArray);
		},
		updateAnswer (state, { qId, index, key, value }) {
			if (state.answers[qId] != null) {
				state.answers[qId][index][key] = value;
			}
		},
		setIsSaving (state, { isSaving }) {
			state.isSaving = isSaving
		},
		setIsLoading (state, { isLoading }) {
			state.isLoading = isLoading;
		},
		setLastSaved (state, { lastSavedTimeStamp }) {
			state.lastSavedTimeStamp = lastSavedTimeStamp;
		},
		setIsSurveyType (state, { isStandardSurvey }) {
			state.standardSurvey = isStandardSurvey;
		},
		setquestionId (state, { questionId }) {
			state.questionId = questionId;
		}
	},
	actions: {
			async loadAnswers (context, payload) {
				const { activeId, qId } = payload;
				try {
						const response = await answerService.loadAnswer(activeId, qId, 'false');
						if (response && response.data) {
							context.commit('setAnswers', { qId, answerArray: response.data });
						}
				} catch (err) {
					if (!err.message.includes('404')) {
						throw err;
					}
					try {
						const response = await answerService.loadAnswer(activeId, qId, 'true');
						if (response && response.data) {
							const answers = response.data.map(a => ({
								...a,
								status: 'Incomplete'
							}));
							context.commit('setAnswers', { qId, answerArray: answers });
						}
					} catch (retryErr) {
						console.log(retryErr);
						throw retryErr;
					}
				}
			},
			async loadAllAnswers (context, { surveyId, qId }) {
				try {
					const response = await answerService.loadAllAnswers(surveyId, qId);
					if (response && response.data) {
						const keyArray = Object.keys(response.data);
						keyArray.forEach(key => {
							context.commit('setAnswers', {
								qId: key,
								answerArray: response.data[key]
							});
						});
					}
				} catch (e) {
					console.error(e);
				}
			},
			async saveAll (context) {
					context.commit('setIsSaving', { isSaving: true });
					try {
						if (!context.state.answers) {
							context.commit('setIsSaving', { isSaving: false });
							return;
						}
						// Save answers
						await answerService.saveAnswers(context.state.answers, true);
						// Reload validation + statuses
						context.dispatch('validation/loadSurveyValidationMessages');
						context.dispatch('validation/loadQuestionStatuses');
						// Update UI state
						context.commit('setIsSaving', { isSaving: false });
						context.commit('setIsLoading', { isLoading: false });
						context.commit('setLastSaved', {
							lastSavedTimeStamp: utilityService.getTimeStamp()
						});
					} catch (err) {
							console.error(err);
							context.commit('setIsSaving', { isSaving: false });
							context.commit('setIsLoading', { isLoading: false });
							context.commit('setLastSaved', {
									lastSavedTimeStamp: 'There was an error saving'
							});
					}
			},
			loadSurveyType (context, { isStandardSurvey }) {
				context.commit('setIsSurveyType', { isStandardSurvey: isStandardSurvey });
			},
			async saveQuestion (context, { qId, expval, expval2, fy1Con, fy1Pla, isStandardSurvey }) {
			debugger;
			// --- Resolve base array -------------------------------------------------
			// If you actually have "answersOfCountries" in state, plug it in here:
			// const answersOfCountries = context.state.answersOfCountries?.[qId] || [];
			const answersOfCountries = []; // fallback: nothing preloaded

			const answers = context.state.answers && context.state.answers[qId];
			if (!Array.isArray(answers) || answers.length === 0) {
				// Nothing to update, avoid 500s from malformed payloads
				return;
			}

			let array;
			if (!isStandardSurvey && qId === 16) {
				if (answersOfCountries.length > 0 &&
					answersOfCountries.length === answers.length) {
					array = answersOfCountries;
				} else {
					array = answers;
				}
			} else if (isStandardSurvey && qId === 14) {
				if (answersOfCountries.length > 0 &&
					answersOfCountries.length === answers.length) {
					array = answersOfCountries;
				} else {
					array = answers;
				}
			} else {
				array = answers;
			}

			// Safety: ensure first element exists
			if (!array[0]) {
				return;
			}
			// --- Update expBox / fy1Con / fy1Pla ------------------------------------
			const first = array[0];
			for (let i = 0; i < Object.keys(first).length; i++) {
				const key = Object.keys(first)[i];

				if (qId === 2) {
					if (key === "expBox1") {
						first.expBox1 = expval;
					}
					if (key === "expBox2") {
						first.expBox2 = expval2;
					}
				} else {
					if (qId === 4) {
						if (key === "fy1Con") {
							first.fy1Con = fy1Con;
						}
						if (key === "fy1Pla") {
							first.fy1Pla = fy1Pla;
						}
					}

					// Non‑standard survey expBox (qId 7 or 17)
					if (!isStandardSurvey && (qId === 7 || qId === 17) && first.a) {
						const aKeys = Object.keys(first.a);
						for (let j = 0; j < aKeys.length; j++) {
							const aKey = aKeys[j];
							if (aKey === "expBox") {
								first.a.expBox = expval;
								if (first.a.expBox != null) {
									first.a.expBox = expval.replace(/(\[.*?);(.*?\])/g, "$1$2");
									first.a.expBox = first.a.expBox.replace(/  +/g, " ");
								}
							}
						}
					}

					// Standard survey expBox (qId 6 or 15)
					if (isStandardSurvey && (qId === 6 || qId === 15) && first.a) {
						const aKeys = Object.keys(first.a);
						for (let j = 0; j < aKeys.length; j++) {
							const aKey = aKeys[j];
							if (aKey === "expBox") {
								first.a.expBox = expval;
								if (first.a.expBox != null) {
									first.a.expBox = expval.replace(/(\[.*?);(.*?\])/g, "$1$2");
									first.a.expBox = first.a.expBox.replace(/  +/g, " ");
								}
							}
						}
					} else if (key === "expBox") {
						first.expBox = expval;
						if (expval != null) {
							first.expBox = expval.replace(/(\[.*?);(.*?\])/g, "$1$2");
							first.expBox = first.expBox.replace(/  +/g, " ");
						}
					}
				}
			}
			// This below condition, to add totals for a specific questions
			if (isStandardSurvey) {
				if (qId === "1" || qId === "3") {
					const row = array[0];
					row.fy1Tot = row.fy1Con + row.fy1Pla;
					row.fy2Tot = row.fy2Con + row.fy2Pla;
				}
				if (qId === "5") {
					const row = array[0];
					row.fy1Tot = row.fy1Bas + row.fy1App + row.fy1Exp;
					row.fy2Tot = row.fy2Bas + row.fy2App + row.fy2Exp;
				}
				if (qId === "6" || qId === "15") {
					// a
					array[0].a.totCis = array[0].a.bascCis + array[0].a.apldCis + array[0].a.epCis;
					// b
					array[0].b.totAtm = array[0].b.basAtm + array[0].b.appAtm + array[0].b.expAtm;
					array[0].b.totGeo = array[0].b.basGeo + array[0].b.appGeo + array[0].b.expGeo;
					array[0].b.totOce = array[0].b.basOce + array[0].b.appOce + array[0].b.expOce;
					array[0].b.totEnvrnNec = array[0].b.bascEnvrnNec + array[0].b.apldEnvrnNec + array[0].b.epEnvrnNec;

					array[0].b.bascEnvrnTot = array[0].b.basAtm + array[0].b.basGeo + array[0].b.basOce + array[0].b.bascEnvrnNec;
					array[0].b.apldEnvrnTot = array[0].b.appAtm + array[0].b.appGeo + array[0].b.appOce + array[0].b.apldEnvrnNec;
					array[0].b.epEnvrnTot = array[0].b.expAtm + array[0].b.expGeo + array[0].b.expOce + array[0].b.epEnvrnNec;
					array[0].b.totEnvrnTot = array[0].b.bascEnvrnTot + array[0].b.apldEnvrnTot + array[0].b.epEnvrnTot;
					// c
					array[0].c.totAgr = array[0].c.basAgr + array[0].c.appAgr + array[0].c.expAgr;
					array[0].c.totLifeBio = array[0].c.bascLifeBio + array[0].c.apldLifeBio + array[0].c.epLifeBio;
					array[0].c.totHea = array[0].c.basHea + array[0].c.appHea + array[0].c.expHea;
					array[0].c.totNat = array[0].c.basNat + array[0].c.appNat + array[0].c.expNat;
					array[0].c.totLifeNec = array[0].c.bascLifeNec + array[0].c.apldLifeNec + array[0].c.epLifeNec;
					array[0].c.bascLifeTot = array[0].c.basAgr + array[0].c.bascLifeBio + array[0].c.basHea + array[0].c.basNat + array[0].c.bascLifeNec;
					array[0].c.apldLifeTot = array[0].c.appAgr + array[0].c.apldLifeBio + array[0].c.appHea + array[0].c.appNat + array[0].c.apldLifeNec;
					array[0].c.epLifeTot = array[0].c.expAgr + array[0].c.epLifeBio + array[0].c.expHea + array[0].c.expNat + array[0].c.epLifeNec;
					array[0].c.totLifeTot = array[0].c.bascLifeTot + array[0].c.apldLifeTot + array[0].c.epLifeTot;
					// d
					array[0].d.totMath = array[0].d.bascMath + array[0].d.apldMath + array[0].d.epMath;
					// e
					array[0].e.totAst = array[0].e.basAst + array[0].e.appAst + array[0].e.expAst;
					array[0].e.totPhysChem = array[0].e.bascPhysChem + array[0].e.apldPhysChem + array[0].e.epPhysChem;
					array[0].e.totPhysMatl = array[0].e.bascPhysMatl + array[0].e.apldPhysMatl + array[0].e.epPhysMatl;
					array[0].e.totPhy = array[0].e.basPhy + array[0].e.appPhy + array[0].e.expPhy;
					array[0].e.totPhysNec = array[0].e.bascPhysNec + array[0].e.apldPhysNec + array[0].e.epPhysNec;

					array[0].e.bascPhysTot = array[0].e.basAst + array[0].e.bascPhysChem + array[0].e.bascPhysMatl + array[0].e.basPhy + array[0].e.bascPhysNec;
					array[0].e.apldPhysTot = array[0].e.appAst + array[0].e.apldPhysChem + array[0].e.apldPhysMatl + array[0].e.appPhy + array[0].e.apldPhysNec;
					array[0].e.epPhysTot = array[0].e.expAst + array[0].e.epPhysChem + array[0].e.epPhysMatl + array[0].e.expPhy + array[0].e.epPhysNec;
					array[0].e.totPhysTot = array[0].e.bascPhysTot + array[0].e.apldPhysTot + array[0].e.epPhysTot;

					// f
					array[0].f.totPsychBio = array[0].f.bascPsychBio + array[0].f.apldPsychBio + array[0].f.epPsychBio;
					array[0].f.totPsychSoc = array[0].f.bascPsychSoc + array[0].f.apldPsychSoc + array[0].f.epPsychSoc;
					array[0].f.totPsychNec = array[0].f.bascPsychNec + array[0].f.apldPsychNec + array[0].f.epPsychNec;

					array[0].f.bascPsychTot = array[0].f.bascPsychBio + array[0].f.bascPsychSoc + array[0].f.bascPsychNec;
					array[0].f.apldPsychTot = array[0].f.apldPsychBio + array[0].f.apldPsychSoc + array[0].f.apldPsychNec;
					array[0].f.epPsychTot = array[0].f.epPsychBio + array[0].f.epPsychSoc + array[0].f.epPsychNec;
					array[0].f.totPsychTot = array[0].f.bascPsychTot + array[0].f.apldPsychTot + array[0].f.epPsychTot;

					// g
					array[0].g.totAnt = array[0].g.basAnt + array[0].g.appAnt + array[0].g.expAnt;
					array[0].g.totEco = array[0].g.basEco + array[0].g.appEco + array[0].g.expEco;
					array[0].g.totPol = array[0].g.basPol + array[0].g.appPol + array[0].g.expPol;
					array[0].g.totSocSocio = array[0].g.bascSocSocio + array[0].g.apldSocSocio + array[0].g.epSocSocio;
					array[0].g.totSocNec = array[0].g.bascSocNec + array[0].g.apldSocNec + array[0].g.epSocNec;

					array[0].g.bascSocTot = array[0].g.basAnt + array[0].g.basEco + array[0].g.basPol + array[0].g.bascSocSocio + array[0].g.bascSocNec;
					array[0].g.apldSocTot = array[0].g.appAnt + array[0].g.appEco + array[0].g.appPol + array[0].g.apldSocSocio + array[0].g.apldSocNec;
					array[0].g.epSocTot = array[0].g.expAnt + array[0].g.expEco + array[0].g.expPol + array[0].g.epSocSocio + array[0].g.epSocNec;
					array[0].g.totSocTot = array[0].g.bascSocTot + array[0].g.apldSocTot + array[0].g.epSocTot;

					// h
					array[0].h.totAer = array[0].h.basAer + array[0].h.appAer + array[0].h.expAer;
					array[0].h.totEngBio = array[0].h.bascEngBio + array[0].h.apldEngBio + array[0].h.epEngBio;
					array[0].h.totEngChem = array[0].h.bascEngChem + array[0].h.apldEngChem + array[0].h.epEngChem;
					array[0].h.totCiv = array[0].h.basCiv + array[0].h.appCiv + array[0].h.expCiv;
					array[0].h.totEle = array[0].h.basEle + array[0].h.appEle + array[0].h.expEle;
					array[0].h.totInd = array[0].h.basInd + array[0].h.appInd + array[0].h.expInd;
					array[0].h.totMec = array[0].h.basMec + array[0].h.appMec + array[0].h.expMec;
					array[0].h.totMet = array[0].h.basMet + array[0].h.appMet + array[0].h.expMet;
					array[0].h.totEngNec = array[0].h.bascEngNec + array[0].h.apldEngNec + array[0].h.epEngNec;
					array[0].h.bascEngTot = array[0].h.basAer + array[0].h.bascEngBio  + array[0].h.bascEngChem + array[0].h.basCiv + array[0].h.basEle + array[0].h.basInd + array[0].h.basMec + array[0].h.basMet + array[0].h.bascEngNec;
					array[0].h.apldEngTot = array[0].h.appAer + array[0].h.apldEngBio  + array[0].h.apldEngChem + array[0].h.appCiv + array[0].h.appEle + array[0].h.appInd + array[0].h.appMec + array[0].h.appMet + array[0].h.apldEngNec;
					array[0].h.epEngTot = array[0].h.expAer + array[0].h.epEngBio  + array[0].h.epEngChem + array[0].h.expCiv + array[0].h.expEle + array[0].h.expInd + array[0].h.expMec + array[0].h.expMet + array[0].h.epEngNec;
					array[0].h.totEngTot = array[0].h.bascEngTot + array[0].h.apldEngTot + array[0].h.epEngTot;

					// i
					array[0].i.totBus = array[0].i.basBus + array[0].i.appBus + array[0].i.expBus;
					array[0].i.totOthCom = array[0].i.bascOthCom + array[0].i.apldOthCom + array[0].i.epOthCom;
					array[0].i.totEdu = array[0].i.basEdu + array[0].i.appEdu + array[0].i.expEdu;
					array[0].i.totHum = array[0].i.basHum + array[0].i.appHum + array[0].i.expHum;
					array[0].i.totLaw = array[0].i.basLaw + array[0].i.appLaw + array[0].i.expLaw;
					array[0].i.totOthSoc = array[0].i.bascOthSoc + array[0].i.apldOthSoc + array[0].i.epOthSoc;
					array[0].i.totVis = array[0].i.basVis + array[0].i.appVis + array[0].i.expVis;
					array[0].i.totOthNec = array[0].i.bascOthNec + array[0].i.apldOthNec + array[0].i.epOthNec;
					array[0].i.bascOthTot = array[0].i.basBus + array[0].i.bascOthCom + array[0].i.basEdu + array[0].i.basHum  + array[0].i.basLaw + array[0].i.bascOthSoc + array[0].i.basVis + array[0].i.bascOthNec;
					array[0].i.apldOthTot = array[0].i.appBus + array[0].i.apldOthCom + array[0].i.appEdu + array[0].i.appHum  + array[0].i.appLaw + array[0].i.apldOthSoc + array[0].i.appVis + array[0].i.apldOthNec;
					array[0].i.epOthTot = array[0].i.expBus + array[0].i.epOthCom + array[0].i.expEdu + array[0].i.expHum  + array[0].i.expLaw + array[0].i.epOthSoc + array[0].i.expVis + array[0].i.epOthNec;
					array[0].i.totOthTot = array[0].i.bascOthTot + array[0].i.apldOthTot + array[0].i.epOthTot;

					// j
					var basComa = isNaN(array[0].a.bascCis) ? 0 : array[0].a.bascCis;
					var basTotb = isNaN(array[0].b.bascEnvrnTot) ? 0 : array[0].b.bascEnvrnTot;
					var basTotc = isNaN(array[0].c.bascLifeTot) ? 0 : array[0].c.bascLifeTot;
					var basMatd = isNaN(array[0].d.bascMath) ? 0 : array[0].d.bascMath;
					var basTote = isNaN(array[0].e.bascPhysTot) ? 0 : array[0].e.bascPhysTot;
					var basTotf = isNaN(array[0].f.bascPsychTot) ? 0 : array[0].f.bascPsychTot;
					var basTotg = isNaN(array[0].g.bascSocTot) ? 0 : array[0].g.bascSocTot;
					var basToth = isNaN(array[0].h.bascEngTot) ? 0 : array[0].h.bascEngTot
					var basToti = isNaN(array[0].i.bascOthTot) ? 0 : array[0].i.bascOthTot;
					array[0].j.basTot = basComa + basTotb + basTotc + basMatd + basTote + basTotf + basTotg + basToth + basToti;
					var appComa = isNaN(array[0].a.apldCis) ? 0 : parseInt(array[0].a.apldCis);
					var appTotb = isNaN(array[0].b.apldEnvrnTot) ? 0 : parseInt(array[0].b.apldEnvrnTot);
					var appTotc = isNaN(array[0].c.apldLifeTot) ? 0 : parseInt(array[0].c.apldLifeTot);
					var appMatd = isNaN(array[0].d.apldMath) ? 0 : parseInt(array[0].d.apldMath);
					var appTote = isNaN(array[0].e.apldPhysTot) ? 0 : parseInt(array[0].e.apldPhysTot);
					var appTotf = isNaN(array[0].f.apldPsychTot) ? 0 : parseInt(array[0].f.apldPsychTot);
					var appTotg = isNaN(array[0].g.apldSocTot) ? 0 : parseInt(array[0].g.apldSocTot);
					var appToth = isNaN(array[0].h.apldEngTot) ? 0 : parseInt(array[0].h.apldEngTot);
					var appToti = isNaN(array[0].i.apldOthTot) ? 0 : parseInt(array[0].i.apldOthTot);
					array[0].j.appTot = appComa + appTotb + appTotc + appMatd + appTote + appTotf + appTotg + appToth + appToti;
					var expComa = isNaN(array[0].a.epCis) ? 0 : parseInt(array[0].a.epCis);
					var expTotb = isNaN(array[0].b.epEnvrnTot) ? 0 : parseInt(array[0].b.epEnvrnTot);
					var expTotc = isNaN(array[0].c.epLifeTot) ? 0 : parseInt(array[0].c.epLifeTot);
					var expMatd = isNaN(array[0].d.epMath) ? 0 : parseInt(array[0].d.epMath);
					var expTote = isNaN(array[0].e.epPhysTot) ? 0 : parseInt(array[0].e.epPhysTot);
					var expTotf = isNaN(array[0].f.epPsychTot) ? 0 : parseInt(array[0].f.epPsychTot);
					var expTotg = isNaN(array[0].g.epSocTot) ? 0 : parseInt(array[0].g.epSocTot);
					var expToth = isNaN(array[0].h.epEngTot) ? 0 : parseInt(array[0].h.epEngTot);
					var expToti = isNaN(array[0].i.epOthTot) ? 0 : parseInt(array[0].i.epOthTot);
					array[0].j.expTot = expComa + expTotb + expTotc + expMatd + expTote + expTotf + expTotg + expToth + expToti;
					array[0].j.totTot = array[0].j.basTot + array[0].j.appTot + array[0].j.expTot;
				}
				if (qId === "7") {
					array[0].totCom = array[0].basCom + array[0].appCom + array[0].expCom;
					array[0].totGeo = array[0].basGeo + array[0].appGeo + array[0].expGeo;
					array[0].totLif = array[0].basLif + array[0].appLif + array[0].expLif;
					array[0].totMat = array[0].basMat + array[0].appMat + array[0].expMat;
					array[0].totPhy = array[0].basPhy + array[0].appPhy + array[0].expPhy;
					array[0].totPsy = array[0].basPsy + array[0].appPsy + array[0].expPsy;
					array[0].totSoc = array[0].basSoc + array[0].appSoc + array[0].expSoc;
					array[0].totEng = array[0].basEng + array[0].appEng + array[0].expEng;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth;

					array[0].basTot = array[0].basCom + array[0].basEng + array[0].basGeo + array[0].basLif + array[0].basMat + array[0].basOth + array[0].basPhy + array[0].basPsy + array[0].basSoc;
					array[0].appTot = array[0].appCom + array[0].appEng + array[0].appGeo + array[0].appLif + array[0].appMat + array[0].appOth + array[0].appPhy + array[0].appPsy + array[0].appSoc;
					array[0].expTot = array[0].expCom + array[0].expEng + array[0].expGeo + array[0].expLif + array[0].expMat + array[0].expOth + array[0].expPhy + array[0].expPsy + array[0].expSoc;
					array[0].totTot = array[0].totCom + array[0].totEng + array[0].totGeo + array[0].totLif + array[0].totMat + array[0].totOth + array[0].totPhy + array[0].totPsy + array[0].totSoc;
				}
				if (qId === "8") {
					// a-b
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].expFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].expFun + array[0].plaFun;
					// c-g
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].expBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].expHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].expSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].expNon + array[0].plaNon;

					array[0].basTotNon = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotNon = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].expTotNon = array[0].expBus + array[0].expHig + array[0].expOth + array[0].expSta + array[0].expNon;
					array[0].plaTotNon = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;
					// Total H
					array[0].totTotNon = array[0].basTotNon + array[0].appTotNon + array[0].expTotNon + array[0].plaTotNon;
					// i
					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotNon;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotNon;
					array[0].expTot = array[0].expFed + array[0].expFun + array[0].expTotNon;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotNon;
					// Total
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].expTot + array[0].plaTot;
				}
				if (qId === "9") {
					// a-b
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].expFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].expFun + array[0].plaFun;
					// c-g
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].expBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].expHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].expSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].expNon + array[0].plaNon;

					array[0].basTotNon = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotNon = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].expTotNon = array[0].expBus + array[0].expHig + array[0].expOth + array[0].expSta + array[0].expNon;
					array[0].plaTotNon = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;
					// Total H
					array[0].totTotNon = array[0].basTotNon + array[0].appTotNon + array[0].expTotNon + array[0].plaTotNon;
					// i
					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotNon;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotNon;
					array[0].expTot = array[0].expFed + array[0].expFun + array[0].expTotNon;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotNon;
					// Total
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].expTot + array[0].plaTot;
				}
				if (qId === "10") {
					array[0].totCon = array[0].conCon + array[0].plaCon;
					array[0].totGra = array[0].conGra + array[0].plaGra;
					array[0].contot = array[0].conCon + array[0].conGra;
					array[0].platot = array[0].plaCon + array[0].plaGra;
					array[0].tottot = array[0].contot + array[0].platot;
				}
				if (qId === "11") {
					// Mapping of index → federalagencyid
					const agencyMap = [
						"000007", "000008", "000047", "000018", "000019", "000021", "000035", "000045",
						"000046", "000010", "000011", "000012", "000013", "000020", "000015", "000016",
						"000017", "000023", "000022", "000024", "000048", "000003", "000004", "000006",
						"000025", "000027", "000030", "000031", "000033", "000034", "000049", "000043",
						"000037", "000038", "000039", "000040", "000036", "000042"
					];
					// 1. Assign totals + federalagencyid for rows 0–37
					array.forEach((row, idx) => {
						row.tot = row.con + row.pla;
						const id = agencyMap[idx];
						if (id) row.federalagencyid = id;
					});
					// 2. Compute grand totals (exclude the last row "000042")
					let con = 0;
					let pla = 0;
					for (let i = 0; i < array.length; i++) {
						if (array[i].federalagencyid !== "000042") {
							con += array[i].con;
							pla += array[i].pla;
						}
					}
					// 3. Write totals into the last row (index 37)
					const totalRow = array[37];
					totalRow.con = con;
					totalRow.pla = pla;
					totalRow.tot = con + pla;
					totalRow.federalagencyid = "000042";
				}
				if (qId === "12" || qId === "13")	{
					array[0].tot = array[0].fed + array[0].ffr + array[0].bus + array[0].edu + array[0].oth + array[0].sta;
					array[0].stateId = "10061";
					array[1].tot = array[1].fed + array[1].ffr + array[1].bus + array[1].edu + array[1].oth + array[1].sta;
					array[1].stateId = "11091";
					array[2].tot = array[2].fed + array[2].ffr + array[2].bus + array[2].edu + array[2].oth + array[2].sta;
					array[2].stateId = "12081";
					array[3].tot = array[3].fed + array[3].ffr + array[3].bus + array[3].edu + array[3].oth + array[3].sta;
					array[3].stateId = "13071";
					array[4].tot = array[4].fed + array[4].ffr + array[4].bus + array[4].edu + array[4].oth + array[4].sta;
					array[4].stateId = "14092";
					array[5].tot = array[5].fed + array[5].ffr + array[5].bus + array[5].edu + array[5].oth + array[5].sta;
					array[5].stateId = "15082";
					array[6].tot = array[6].fed + array[6].ffr + array[6].bus + array[6].edu + array[6].oth + array[6].sta;
					array[6].stateId = "16011";
					array[7].tot = array[7].fed + array[7].ffr + array[7].bus + array[7].edu + array[7].oth + array[7].sta;
					array[7].stateId = "17051";
					array[8].tot = array[8].fed + array[8].ffr + array[8].bus + array[8].edu + array[8].oth + array[8].sta;
					array[8].stateId = "18052";
					array[9].tot = array[9].fed + array[9].ffr + array[9].bus + array[9].edu + array[9].oth + array[9].sta;
					array[9].stateId = "19053";
					array[10].tot = array[10].fed + array[10].ffr + array[10].bus + array[10].edu + array[10].oth + array[10].sta;
					array[10].stateId = "20054";
					array[11].tot = array[11].fed + array[11].ffr + array[11].bus + array[11].edu + array[11].oth + array[11].sta;
					array[11].stateId = "21093";
					array[12].tot = array[12].fed + array[12].ffr + array[12].bus + array[12].edu + array[12].oth + array[12].sta;
					array[12].stateId = "22083";
					array[13].tot = array[13].fed + array[13].ffr + array[13].bus + array[13].edu + array[13].oth + array[13].sta;
					array[13].stateId = "23031";
					array[14].tot = array[14].fed + array[14].ffr + array[14].bus + array[14].edu + array[14].oth + array[14].sta;
					array[14].stateId = "24032";
					array[15].tot = array[15].fed + array[15].ffr + array[15].bus + array[15].edu + array[15].oth + array[15].sta;
					array[15].stateId = "25041";
					array[16].tot = array[16].fed + array[16].ffr + array[16].bus + array[16].edu + array[16].oth + array[16].sta;
					array[16].stateId = "26042";
					array[17].tot = array[17].fed + array[17].ffr + array[17].bus + array[17].edu + array[17].oth + array[17].sta;
					array[17].stateId = "27062";
					array[18].tot = array[18].fed + array[18].ffr + array[18].bus + array[18].edu + array[18].oth + array[18].sta;
					array[18].stateId = "28072";
					array[19].tot = array[19].fed + array[19].ffr + array[19].bus + array[19].edu + array[19].oth + array[19].sta;
					array[19].stateId = "29012";
					array[20].tot = array[20].fed + array[20].ffr + array[20].bus + array[20].edu + array[20].oth + array[20].sta;
					array[20].stateId = "30055";
					array[21].tot = array[21].fed + array[21].ffr + array[21].bus + array[21].edu + array[21].oth + array[21].sta;
					array[21].stateId = "31013";
					array[22].tot = array[22].fed + array[22].ffr + array[22].bus + array[22].edu + array[22].oth + array[22].sta;
					array[22].stateId = "32033";
					array[23].tot = array[23].fed + array[23].ffr + array[23].bus + array[23].edu + array[23].oth + array[23].sta;
					array[23].stateId = "33043";
					array[24].tot = array[24].fed + array[24].ffr + array[24].bus + array[24].edu + array[24].oth + array[24].sta;
					array[24].stateId = "34063";
					array[25].tot = array[25].fed + array[25].ffr + array[25].bus + array[25].edu + array[25].oth + array[25].sta;
					array[25].stateId = "35044";
					array[26].tot = array[26].fed + array[26].ffr + array[26].bus + array[26].edu + array[26].oth + array[26].sta;
					array[26].stateId = "36084";
					array[27].tot = array[27].fed + array[27].ffr + array[27].bus + array[27].edu + array[27].oth + array[27].sta;
					array[27].stateId = "37045";
					array[28].tot = array[28].fed + array[28].ffr + array[28].bus + array[28].edu + array[28].oth + array[28].sta;
					array[28].stateId = "38085";
					array[29].tot = array[29].fed + array[29].ffr + array[29].bus + array[29].edu + array[29].oth + array[29].sta;
					array[29].stateId = "39014";
					array[30].tot = array[30].fed + array[30].ffr + array[30].bus + array[30].edu + array[30].oth + array[30].sta;
					array[30].stateId = "40021";
					array[31].tot = array[31].fed + array[31].ffr + array[31].bus + array[31].edu + array[31].oth + array[31].sta;
					array[31].stateId = "41086";
					array[32].tot = array[32].fed + array[32].ffr + array[32].bus + array[32].edu + array[32].oth + array[32].sta;
					array[32].stateId = "42022";
					array[33].tot = array[33].fed + array[33].ffr + array[33].bus + array[33].edu + array[33].oth + array[33].sta;
					array[33].stateId = "43056";
					array[34].tot = array[34].fed + array[34].ffr + array[34].bus + array[34].edu + array[34].oth + array[34].sta;
					array[34].stateId = "44046";
					array[35].tot = array[35].fed + array[35].ffr + array[35].bus + array[35].edu + array[35].oth + array[35].sta;
					array[35].stateId = "45034";
					array[36].tot = array[36].fed + array[36].ffr + array[36].bus + array[36].edu + array[36].oth + array[36].sta;
					array[36].stateId = "46073";
					array[37].tot = array[37].fed + array[37].ffr + array[37].bus + array[37].edu + array[37].oth + array[37].sta;
					array[37].stateId = "47094";
					array[38].tot = array[38].fed + array[38].ffr + array[38].bus + array[38].edu + array[38].oth + array[38].sta;
					array[38].stateId = "48023";
					array[39].tot = array[39].fed + array[39].ffr + array[39].bus + array[39].edu + array[39].oth + array[39].sta;
					array[39].stateId = "49015";
					array[40].tot = array[40].fed + array[40].ffr + array[40].bus + array[40].edu + array[40].oth + array[40].sta;
					array[40].stateId = "50057";
					array[41].tot = array[41].fed + array[41].ffr + array[41].bus + array[41].edu + array[41].oth + array[41].sta;
					array[41].stateId = "51047";
					array[42].tot = array[42].fed + array[42].ffr + array[42].bus + array[42].edu + array[42].oth + array[42].sta;
					array[42].stateId = "52064";
					array[43].tot = array[43].fed + array[43].ffr + array[43].bus + array[43].edu + array[43].oth + array[43].sta;
					array[43].stateId = "53074";
					array[44].tot = array[44].fed + array[44].ffr + array[44].bus + array[44].edu + array[44].oth + array[44].sta;
					array[44].stateId = "54087";
					array[45].tot = array[45].fed + array[45].ffr + array[45].bus + array[45].edu + array[45].oth + array[45].sta;
					array[45].stateId = "55016";
					array[46].tot = array[46].fed + array[46].ffr + array[46].bus + array[46].edu + array[46].oth + array[46].sta;
					array[46].stateId = "56058";
					array[47].tot = array[47].fed + array[47].ffr + array[47].bus + array[47].edu + array[47].oth + array[47].sta;
					array[47].stateId = "57095";
					array[48].tot = array[48].fed + array[48].ffr + array[48].bus + array[48].edu + array[48].oth + array[48].sta;
					array[48].stateId = "58059";
					array[49].tot = array[49].fed + array[49].ffr + array[49].bus + array[49].edu + array[49].oth + array[49].sta;
					array[49].stateId = "59035";
					array[50].tot = array[50].fed + array[50].ffr + array[50].bus + array[50].edu + array[50].oth + array[50].sta;
					array[50].stateId = "60088";
					array[51].tot = array[51].fed + array[51].ffr + array[51].bus + array[51].edu + array[51].oth + array[51].sta;
					array[51].stateId = "70000";
					array[52].tot = array[52].fed + array[52].ffr + array[52].bus + array[52].edu + array[52].oth + array[52].sta;
					array[52].stateId = "70001";
					array[53].tot = array[53].fed + array[53].ffr + array[53].bus + array[53].edu + array[53].oth + array[53].sta;
					array[53].stateId = "70002";
					array[54].tot = array[54].fed + array[54].ffr + array[54].bus + array[54].edu + array[54].oth + array[54].sta;
					array[54].stateId = "64100";
					array[55].tot = array[55].fed + array[55].ffr + array[55].bus + array[55].edu + array[55].oth + array[55].sta;
					array[55].stateId = "70003";
					array[56].tot = array[56].fed + array[56].ffr + array[56].bus + array[56].edu + array[56].oth + array[56].sta;
					array[56].stateId = "65100";
					array[57].tot = array[57].fed + array[57].ffr + array[57].bus + array[57].edu + array[57].oth + array[57].sta;
					array[57].stateId = "62200";
					var fed = 0;
					var ffr = 0;
					var bus = 0;
					var edu = 0;
					var oth = 0;
					var sta = 0;
					for (var i = 0; i < array.length; i++)
					{
						if (array[i].stateId != 91000)
						{
							fed += array[i].fed;
							ffr += array[i].ffr;
							bus += array[i].bus;
							edu += array[i].edu;
							oth += array[i].oth;
							sta += array[i].sta;
						}
					}
					array[58].fed = fed;
					array[58].ffr = ffr;
					array[58].bus = bus;
					array[58].edu = edu;
					array[58].oth = oth;
					array[58].sta = sta;
					//TOTAL
					array[58].tot = array[58].fed + array[58].ffr + array[58].bus + array[58].edu + array[58].oth + array[58].sta;
					array[58].stateId = "91000";
				}
				if (qId === "14") {
					let con = 0;
					let pla = 0;
					// 1. Handle International organizations (row a)
					const intlRow = array.find(row => row.countryId === "International organizations");
					if (intlRow) {
						intlRow.tot = intlRow.con + intlRow.pla;
						con = intlRow.con;
						pla = intlRow.pla;
					}
					// 2. Sum all normal country rows (exclude International + Total rows)
					for (const row of array) {
						if (
							row.countryId !== "International organizations" &&
							row.countryId !== "Total" &&
							row.countryId !== "Total to non-U.S. performers (a + b)"
						) {
							row.tot = row.con + row.pla;
							con += row.con;
							pla += row.pla;
						}
					}
					// 3. Write totals into the Total row
					const totalRow = array.find(row =>
						row.countryId === "Total" ||
						row.countryId === "Total to non-U.S. performers (a + b)"
					);
					if (totalRow) {
						totalRow.con = con;
						totalRow.pla = pla;
						totalRow.tot = con + pla;
					}
				}
				if (qId === "16" || qId === "17") {
					// 1. ID maps for qId 16 (FFRDC) and qId 17 (UARC)
					const ffrdcIds = [
						"930042", "920011", "920012", "930803", "930013", "930074", "930100", "930075", "930038", "930073",
						"931100", "920064", "910002", "920031", "930905", "930904", "910005", "920024", "920016", "910012",
						"920010", "910011", "930903", "920027", "931110", "930801", "920030", "930066", "930047", "923900",
						"923888", "930004", "930885", "920020", "930065", "910009", "910010", "930900", "920017", "920804",
						"930041", "920066", "940000"
					];
					const uarcIds = [
						"1", "16", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"
					];
					// 2. Running totals
					let bas = 0; let app = 0; let exp = 0; let pla = 0;
					// 3. Loop through rows
					array.forEach((row, i) => {
						const isLast = (i === array.length - 1);

						// Compute totals for all but the last row
						if (!isLast) {
							row.tot = row.bas + row.app + row.exp + row.pla;
							bas += row.bas;
							app += row.app;
							exp += row.exp;
							pla += row.pla;
						}
						// qId 16 → assign FFRDC IDs
						if (qId === 16) {
							if (i < ffrdcIds.length) {
								row.ffrdcId = ffrdcIds[i];
							}
							// Reset totals at the special index (42)
							if (i === 42) {
								row.tot = row.bas + row.app + row.exp + row.pla;
								row.ffrdcId = "940000";
								bas = app = exp = pla = 0;
							}
						}
						// qId 17 → assign UARC IDs
						if (qId === 17) {
							if (i < uarcIds.length) {
								row.uarcid = uarcIds[i];
							}
							// Reset totals at the special index (15)
							if (i === 15) {
								row.tot = row.bas + row.app + row.exp + row.pla;
								row.uarcid = "15";
								bas = app = exp = pla = 0;
							}
						}
					});
				}
				if (qId === "18") {
					let con = 0;
					let pla = 0;
					let seFel = 0;
					let fac = 0;
					let oth = 0;
					// 1. Sum all rows except the "000001" total row
					for (const row of array) {
						if (row.orgCod !== "000001") {
							row.tot = row.con + row.pla;
							con += row.con;
							pla += row.pla;
							seFel += row.seFel;
							fac += row.fac;
							oth += row.oth;
						}
					}
					// 2. Write totals into the "000001" row
					const totalRow = array.find(row => row.orgCod === "000001");
					if (totalRow) {
						totalRow.con = con;
						totalRow.pla = pla;
						totalRow.tot = con + pla;
						totalRow.seFel = seFel;
						totalRow.fac = fac;
						totalRow.oth = oth;
					}
				}
				if (qId === "19") {
					let con = 0;
					let pla = 0;
					// 1. Sum all non‑"000001" rows
					for (const row of array) {
						if (row.orgCod !== "000001") {
							row.tot = row.con + row.pla;
							con += row.con;
							pla += row.pla;
						}
					}
					// 2. Write totals into the "000001" row
					const totalRow = array.find(row => row.orgCod === "000001");
					if (totalRow) {
						totalRow.con = con;
						totalRow.pla = pla;
						totalRow.tot = con + pla;
					}
				}
				if (qId === "20")	{
					array[0].rdFy1ConTot = parseInt(array[0].rdFy1BascRsch) + parseInt(array[0].rdFy1ApldRsch) + parseInt(array[0].rdFy1Exp);
					document.getElementById('rdFy1ConTot_0_20').value = array[0].rdFy1ConTot.toLocaleString();
					array[0].rdFy1ConPlantTot = parseInt(array[0].rdFy1ConTot) + parseInt(array[0].rdFy1PlantTot);
					document.getElementById('rdFy1ConPlantTot_0_20').value = array[0].rdFy1ConPlantTot.toLocaleString();

					array[0].rdFy2ConTot = parseInt(array[0].rdFy2BascRsch) + parseInt(array[0].rdFy2ApldRsch) + parseInt(array[0].rdFy2Exp);
					document.getElementById('rdFy2ConTot_1_20').value = array[0].rdFy2ConTot.toLocaleString();
					array[0].rdFy2ConPlantTot = parseInt(array[0].rdFy2ConTot) + parseInt(array[0].rdFy2PlantTot);
					document.getElementById('rdFy2ConPlantTot_1_20').value = array[0].rdFy2ConPlantTot.toLocaleString();

					array[0].chipsFy1ConTot = parseInt(array[0].chipsFy1BascRsch) + parseInt(array[0].chipsFy1ApldRsch) + parseInt(array[0].chipsFy1Exp);
					document.getElementById('chipsFy1ConTot_2_20').value = array[0].chipsFy1ConTot.toLocaleString();
					array[0].chipsFy1ConPlantTot = parseInt(array[0].chipsFy1ConTot) + parseInt(array[0].chipsFy1PlantTot);
					document.getElementById('chipsFy1ConPlantTot_2_20').value = array[0].chipsFy1ConPlantTot.toLocaleString();

					array[0].chipsFy2ConTot = parseInt(array[0].chipsFy2BascRsch) + parseInt(array[0].chipsFy2ApldRsch) + parseInt(array[0].chipsFy2Exp);
					document.getElementById('chipsFy2ConTot_3_20').value = array[0].chipsFy2ConTot.toLocaleString();
					array[0].chipsFy2ConPlantTot = parseInt(array[0].chipsFy2ConTot) + parseInt(array[0].chipsFy2PlantTot);
					document.getElementById('chipsFy2ConPlantTot_3_20').value = array[0].chipsFy2ConPlantTot.toLocaleString();

					array[0].iraFy1ConTot = parseInt(array[0].iraFy1BascRsch) + parseInt(array[0].iraFy1ApldRsch) + parseInt(array[0].iraFy1Exp);
					document.getElementById('iraFy1ConTot_4_20').value = array[0].iraFy1ConTot.toLocaleString();
					array[0].iraFy1ConPlantTot = parseInt(array[0].iraFy1ConTot) + parseInt(array[0].iraFy1PlantTot);
					document.getElementById('iraFy1ConPlantTot_4_20').value = array[0].iraFy1ConPlantTot.toLocaleString();

					array[0].iraFy2ConTot = parseInt(array[0].iraFy2BascRsch) + parseInt(array[0].iraFy2ApldRsch) + parseInt(array[0].iraFy2Exp);
					document.getElementById('iraFy2ConTot_5_20').value = array[0].iraFy2ConTot.toLocaleString();
					array[0].iraFy2ConPlantTot = parseInt(array[0].iraFy2ConTot) + parseInt(array[0].iraFy2PlantTot);
					document.getElementById('iraFy2ConPlantTot_5_20').value = array[0].iraFy2ConPlantTot.toLocaleString();

					array[0].bilFy1ConTot = parseInt(array[0].bilFy1BascRsch) + parseInt(array[0].bilFy1ApldRsch) + parseInt(array[0].bilFy1Exp);
					document.getElementById('bilFy1ConTot_6_20').value = array[0].bilFy1ConTot.toLocaleString();
					array[0].bilFy1ConPlantTot = parseInt(array[0].bilFy1ConTot) + parseInt(array[0].bilFy1PlantTot);
					document.getElementById('bilFy1ConPlantTot_6_20').value = array[0].bilFy1ConPlantTot.toLocaleString();

					array[0].bilFy2ConTot = parseInt(array[0].bilFy2BascRsch) + parseInt(array[0].bilFy2ApldRsch) + parseInt(array[0].bilFy2Exp);
					document.getElementById('bilFy2ConTot_7_20').value = array[0].bilFy2ConTot.toLocaleString();
					array[0].bilFy2ConPlantTot = parseInt(array[0].bilFy2ConTot) + parseInt(array[0].bilFy2PlantTot);
					document.getElementById('bilFy2ConPlantTot_7_20').value = array[0].bilFy2ConPlantTot.toLocaleString();
				}
			}
			if (!isStandardSurvey) {
				if (qId === "1" || qId === "3") {
					const r = array[0];
					r.fy1TotA = r.fy1Con + r.fy1Ope;
					r.fy2TotA = r.fy2Con + r.fy2Ope;
					r.fy1Tot = r.fy1TotA + r.fy1Pla;
					r.fy2Tot = r.fy2TotA + r.fy2Pla;
				}
				if (qId === "5") {
					const r = array[0];
					r.fy1Tot = r.fy1Bas + r.fy1App + r.fy1Adv + r.fy1Maj + r.fy1Ope;
					r.fy2Tot = r.fy2Bas + r.fy2App + r.fy2Adv + r.fy2Maj + r.fy2Ope;
				}
				if (qId === "6") {
					const r = array[0];
					r.fy1Tot = r.fy1Amount + r.fy1Obl;
					r.fy2Tot = r.fy2Amount + r.fy2Obl;
				}
				if (qId === "7" || qId === "17") {
					array[0].a.totCis = array[0].a.bascCis + array[0].a.apldCis + array[0].a.epCis;
					// b
					array[0].b.totAtm = array[0].b.basAtm + array[0].b.appAtm + array[0].b.expAtm;
					array[0].b.totGeo = array[0].b.basGeo + array[0].b.appGeo + array[0].b.expGeo;
					array[0].b.totOce = array[0].b.basOce + array[0].b.appOce + array[0].b.expOce;
					array[0].b.totEnvrnNec = array[0].b.bascEnvrnNec + array[0].b.apldEnvrnNec + array[0].b.epEnvrnNec;
					array[0].b.bascEnvrnTot = array[0].b.basAtm + array[0].b.basGeo + array[0].b.basOce + array[0].b.bascEnvrnNec;
					array[0].b.apldEnvrnTot = array[0].b.appAtm + array[0].b.appGeo + array[0].b.appOce + array[0].b.apldEnvrnNec;
					array[0].b.epEnvrnTot = array[0].b.expAtm + array[0].b.expGeo + array[0].b.expOce + array[0].b.epEnvrnNec;
					array[0].b.totEnvrnTot = array[0].b.bascEnvrnTot + array[0].b.apldEnvrnTot + array[0].b.epEnvrnTot;
					// c
					array[0].c.totAgr = array[0].c.basAgr + array[0].c.appAgr + array[0].c.expAgr;
					array[0].c.totLifeBio = array[0].c.bascLifeBio + array[0].c.apldLifeBio + array[0].c.epLifeBio;
					array[0].c.totHea = array[0].c.basHea + array[0].c.appHea + array[0].c.expHea;
					array[0].c.totNat = array[0].c.basNat + array[0].c.appNat + array[0].c.expNat;
					array[0].c.totLifeNec = array[0].c.bascLifeNec + array[0].c.apldLifeNec + array[0].c.epLifeNec;
					array[0].c.bascLifeTot = array[0].c.basAgr + array[0].c.bascLifeBio + array[0].c.basHea + array[0].c.basNat + array[0].c.bascLifeNec;
					array[0].c.apldLifeTot = array[0].c.appAgr + array[0].c.apldLifeBio + array[0].c.appHea + array[0].c.appNat + array[0].c.apldLifeNec;
					array[0].c.epLifeTot = array[0].c.expAgr + array[0].c.epLifeBio + array[0].c.expHea + array[0].c.expNat + array[0].c.epLifeNec;
					array[0].c.totLifeTot = array[0].c.bascLifeTot + array[0].c.apldLifeTot + array[0].c.epLifeTot;
					// d
					array[0].d.totMath = array[0].d.bascMath + array[0].d.apldMath + array[0].d.epMath;
					// e
					array[0].e.totAst = array[0].e.basAst + array[0].e.appAst + array[0].e.expAst;
					array[0].e.totPhysChem = array[0].e.bascPhysChem + array[0].e.apldPhysChem + array[0].e.epPhysChem;
					array[0].e.totPhysMatl = array[0].e.bascPhysMatl + array[0].e.apldPhysMatl + array[0].e.epPhysMatl;
					array[0].e.totPhy = array[0].e.basPhy + array[0].e.appPhy + array[0].e.expPhy;
					array[0].e.totPhysNec = array[0].e.bascPhysNec + array[0].e.apldPhysNec + array[0].e.epPhysNec;

					array[0].e.bascPhysTot = array[0].e.basAst + array[0].e.bascPhysChem +  array[0].e.bascPhysMatl + array[0].e.basPhy + array[0].e.bascPhysNec;
					array[0].e.apldPhysTot = array[0].e.appAst + array[0].e.apldPhysChem +  array[0].e.apldPhysMatl + array[0].e.appPhy + array[0].e.apldPhysNec;
					array[0].e.epPhysTot = array[0].e.expAst + array[0].e.epPhysChem + array[0].e.epPhysMatl + array[0].e.expPhy + array[0].e.epPhysNec;
					array[0].e.totPhysTot = array[0].e.bascPhysTot + array[0].e.apldPhysTot + array[0].e.epPhysTot;

					// f
					array[0].f.totPsychBio = array[0].f.bascPsychBio + array[0].f.apldPsychBio + array[0].f.epPsychBio;
					array[0].f.totPsychSoc = array[0].f.bascPsychSoc + array[0].f.apldPsychSoc + array[0].f.epPsychSoc;
					array[0].f.totPsychNec = array[0].f.bascPsychNec + array[0].f.apldPsychNec + array[0].f.epPsychNec;

					array[0].f.bascPsychTot = array[0].f.bascPsychBio + array[0].f.bascPsychSoc + array[0].f.bascPsychNec;
					array[0].f.apldPsychTot = array[0].f.apldPsychBio + array[0].f.apldPsychSoc + array[0].f.apldPsychNec;
					array[0].f.epPsychTot = array[0].f.epPsychBio + array[0].f.epPsychSoc + array[0].f.epPsychNec;
					array[0].f.totPsychTot = array[0].f.bascPsychTot + array[0].f.apldPsychTot + array[0].f.epPsychTot;

					// g
					array[0].g.totAnt = array[0].g.basAnt + array[0].g.appAnt + array[0].g.expAnt;
					array[0].g.totEco = array[0].g.basEco + array[0].g.appEco + array[0].g.expEco;
					array[0].g.totPol = array[0].g.basPol + array[0].g.appPol + array[0].g.expPol;
					array[0].g.totSocSocio = array[0].g.bascSocSocio + array[0].g.apldSocSocio + array[0].g.epSocSocio;

					array[0].g.totSocNec = array[0].g.bascSocNec + array[0].g.apldSocNec + array[0].g.epSocNec;
					array[0].g.bascSocTot = array[0].g.basAnt + array[0].g.basEco + array[0].g.basPol + array[0].g.bascSocSocio + array[0].g.bascSocNec;
					array[0].g.apldSocTot = array[0].g.appAnt + array[0].g.appEco + array[0].g.appPol + array[0].g.apldSocSocio + array[0].g.apldSocNec;
					array[0].g.epSocTot = array[0].g.expAnt + array[0].g.expEco + array[0].g.expPol + array[0].g.epSocSocio + array[0].g.epSocNec;
					array[0].g.totSocTot = array[0].g.bascSocTot + array[0].g.apldSocTot + array[0].g.epSocTot;

					// h
					array[0].h.totAer = array[0].h.basAer + array[0].h.appAer + array[0].h.expAer;
					array[0].h.totEngBio = array[0].h.bascEngBio + array[0].h.apldEngBio + array[0].h.epEngBio;
					array[0].h.totEngChem = array[0].h.bascEngChem + array[0].h.apldEngChem + array[0].h.epEngChem;
					array[0].h.totCiv = array[0].h.basCiv + array[0].h.appCiv + array[0].h.expCiv;
					array[0].h.totEle = array[0].h.basEle + array[0].h.appEle + array[0].h.expEle;
					array[0].h.totInd = array[0].h.basInd + array[0].h.appInd + array[0].h.expInd;
					array[0].h.totMec = array[0].h.basMec + array[0].h.appMec + array[0].h.expMec;
					array[0].h.totMet = array[0].h.basMet + array[0].h.appMet + array[0].h.expMet;
					array[0].h.totEngNec = array[0].h.bascEngNec + array[0].h.apldEngNec + array[0].h.epEngNec;

					array[0].h.bascEngTot = array[0].h.basAer + array[0].h.bascEngBio  + array[0].h.bascEngChem + array[0].h.basCiv + array[0].h.basEle + array[0].h.basInd + array[0].h.basMec + array[0].h.basMet + array[0].h.bascEngNec;
					array[0].h.apldEngTot = array[0].h.appAer + array[0].h.apldEngBio  + array[0].h.apldEngChem + array[0].h.appCiv + array[0].h.appEle + array[0].h.appInd + array[0].h.appMec + array[0].h.appMet + array[0].h.apldEngNec;
					array[0].h.epEngTot = array[0].h.expAer + array[0].h.epEngBio  + array[0].h.epEngChem + array[0].h.expCiv + array[0].h.expEle + array[0].h.expInd + array[0].h.expMec + array[0].h.expMet + array[0].h.epEngNec;
					array[0].h.totEngTot = array[0].h.bascEngTot + array[0].h.apldEngTot + array[0].h.epEngTot;

					// i
					array[0].i.totBus = array[0].i.basBus + array[0].i.appBus + array[0].i.expBus;
					array[0].i.totOthCom = array[0].i.bascOthCom + array[0].i.apldOthCom + array[0].i.epOthCom;
					array[0].i.totEdu = array[0].i.basEdu + array[0].i.appEdu + array[0].i.expEdu;
					array[0].i.totHum = array[0].i.basHum + array[0].i.appHum + array[0].i.expHum;
					array[0].i.totLaw = array[0].i.basLaw + array[0].i.appLaw + array[0].i.expLaw;
					array[0].i.totOthSoc = array[0].i.bascOthSoc + array[0].i.apldOthSoc + array[0].i.epOthSoc;
					array[0].i.totVis = array[0].i.basVis + array[0].i.appVis + array[0].i.expVis;
					array[0].i.totOthNec = array[0].i.bascOthNec + array[0].i.apldOthNec + array[0].i.epOthNec;

					array[0].i.bascOthTot = array[0].i.basBus + array[0].i.bascOthCom + array[0].i.basEdu + array[0].i.basHum  + array[0].i.basLaw + array[0].i.bascOthSoc + array[0].i.basVis + array[0].i.bascOthNec;
					array[0].i.apldOthTot = array[0].i.appBus + array[0].i.apldOthCom + array[0].i.appEdu + array[0].i.appHum  + array[0].i.appLaw + array[0].i.apldOthSoc + array[0].i.appVis + array[0].i.apldOthNec;
					array[0].i.epOthTot = array[0].i.expBus + array[0].i.epOthCom + array[0].i.expEdu + array[0].i.expHum  + array[0].i.expLaw + array[0].i.epOthSoc + array[0].i.expVis + array[0].i.epOthNec;
					array[0].i.totOthTot = array[0].i.bascOthTot + array[0].i.apldOthTot + array[0].i.epOthTot;

					// j
					// eslint-disable-next-line no-redeclare
					var basComa = isNaN(array[0].a.bascCis) ? 0 : array[0].a.bascCis;
					// eslint-disable-next-line no-redeclare
					var basTotb = isNaN(array[0].b.bascEnvrnTot) ? 0 : array[0].b.bascEnvrnTot;
					// eslint-disable-next-line no-redeclare
					var basTotc = isNaN(array[0].c.bascLifeTot) ? 0 : array[0].c.bascLifeTot;
					// eslint-disable-next-line no-redeclare
					var basMatd = isNaN(array[0].d.bascMath) ? 0 : array[0].d.bascMath;
					// eslint-disable-next-line no-redeclare
					var basTote = isNaN(array[0].e.bascPhysTot) ? 0 : array[0].e.bascPhysTot;
					// eslint-disable-next-line no-redeclare
					var basTotf = isNaN(array[0].f.bascPsychTot) ? 0 : array[0].f.bascPsychTot;
					// eslint-disable-next-line no-redeclare
					var basTotg = isNaN(array[0].g.bascSocTot) ? 0 : array[0].g.bascSocTot;
					// eslint-disable-next-line no-redeclare
					var basToth = isNaN(array[0].h.bascEngTot) ? 0 : array[0].h.bascEngTot;
					// eslint-disable-next-line no-redeclare
					var basToti = isNaN(array[0].i.bascOthTot) ? 0 : array[0].i.bascOthTot;
					array[0].j.basTot = basComa + basTotb + basTotc + basMatd + basTote + basTotf + basTotg + basToth + basToti;

					// eslint-disable-next-line no-redeclare
					var appComa = isNaN(array[0].a.apldCis) ? 0 : parseInt(array[0].a.apldCis);
					// eslint-disable-next-line no-redeclare
					var appTotb = isNaN(array[0].b.apldEnvrnTot) ? 0 : parseInt(array[0].b.apldEnvrnTot);
					// eslint-disable-next-line no-redeclare
					var appTotc = isNaN(array[0].c.apldLifeTot) ? 0 : parseInt(array[0].c.apldLifeTot);
					// eslint-disable-next-line no-redeclare
					var appMatd = isNaN(array[0].d.apldMath) ? 0 : parseInt(array[0].d.apldMath);
					// eslint-disable-next-line no-redeclare
					var appTote = isNaN(array[0].e.apldPhysTot) ? 0 : parseInt(array[0].e.apldPhysTot);
					// eslint-disable-next-line no-redeclare
					var appTotf = isNaN(array[0].f.apldPsychTot) ? 0 : parseInt(array[0].f.apldPsychTot);
					// eslint-disable-next-line no-redeclare
					var appTotg = isNaN(array[0].g.apldSocTot) ? 0 : parseInt(array[0].g.apldSocTot);
					// eslint-disable-next-line no-redeclare
					var appToth = isNaN(array[0].h.apldEngTot) ? 0 : parseInt(array[0].h.apldEngTot);
					// eslint-disable-next-line no-redeclare
					var appToti = isNaN(array[0].i.apldOthTot) ? 0 : parseInt(array[0].i.apldOthTot);
					array[0].j.appTot = appComa + appTotb + appTotc + appMatd + appTote + appTotf + appTotg + appToth + appToti;

					// eslint-disable-next-line no-redeclare
					var expComa = isNaN(array[0].a.epCis) ? 0 : parseInt(array[0].a.epCis);
					// eslint-disable-next-line no-redeclare
					var expTotb = isNaN(array[0].b.epEnvrnTot) ? 0 : parseInt(array[0].b.epEnvrnTot);
					// eslint-disable-next-line no-redeclare
					var expTotc = isNaN(array[0].c.epLifeTot) ? 0 : parseInt(array[0].c.epLifeTot);
					var expMat = isNaN(array[0].d.epMath) ? 0 : parseInt(array[0].d.epMath);
					// eslint-disable-next-line no-redeclare
					var expTote = isNaN(array[0].e.epPhysTot) ? 0 : parseInt(array[0].e.epPhysTot);
					// eslint-disable-next-line no-redeclare
					var expTotf = isNaN(array[0].f.epPsychTot) ? 0 : parseInt(array[0].f.epPsychTot);
					// eslint-disable-next-line no-redeclare
					var expTotg = isNaN(array[0].g.epSocTot) ? 0 : parseInt(array[0].g.epSocTot);
					// eslint-disable-next-line no-redeclare
					var expToth = isNaN(array[0].h.epEngTot) ? 0 : parseInt(array[0].h.epEngTot);
					// eslint-disable-next-line no-redeclare
					var expToti = isNaN(array[0].i.epOthTot) ? 0 : parseInt(array[0].i.epOthTot);
					array[0].j.expTot = expComa + expTotb + expTotc + expMat + expTote + expTotf + expTotg + expToth + expToti;
					array[0].j.totTot = array[0].j.basTot + array[0].j.appTot + array[0].j.expTot;
				}
				if (qId === "8") {
					array[0].totCom = array[0].basCom + array[0].appCom + array[0].expCom;
					array[0].totGeo = array[0].basGeo + array[0].appGeo + array[0].expGeo;
					array[0].totLif = array[0].basLif + array[0].appLif + array[0].expLif;
					array[0].totMat = array[0].basMat + array[0].appMat + array[0].expMat;
					array[0].totPhy = array[0].basPhy + array[0].appPhy + array[0].expPhy;
					array[0].totPsy = array[0].basPsy + array[0].appPsy + array[0].expPsy;
					array[0].totSoc = array[0].basSoc + array[0].appSoc + array[0].expSoc;
					array[0].totEng = array[0].basEng + array[0].appEng + array[0].expEng;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].expOth;

					array[0].basTot = array[0].basCom + array[0].basEng + array[0].basGeo + array[0].basLif + array[0].basMat + array[0].basOth + array[0].basPhy + array[0].basPsy + array[0].basSoc;
					array[0].appTot = array[0].appCom + array[0].appEng + array[0].appGeo + array[0].appLif + array[0].appMat + array[0].appOth + array[0].appPhy + array[0].appPsy + array[0].appSoc;
					array[0].expTot = array[0].expCom + array[0].expEng + array[0].expGeo + array[0].expLif + array[0].expMat + array[0].expOth + array[0].expPhy + array[0].expPsy + array[0].expSoc;
					array[0].totTot = array[0].totCom + array[0].totEng + array[0].totGeo + array[0].totLif + array[0].totMat + array[0].totOth + array[0].totPhy + array[0].totPsy + array[0].totSoc;
				} if (qId === "9")	{
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].advFed + array[0].majFed + array[0].opeFed + array[0].plaFed;
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].advFun + array[0].majFun + array[0].opeFun + array[0].plaFun;
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].advBus + array[0].majBus + array[0].opeBus + array[0].plaBus;
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].advHig + array[0].majHig + array[0].opeHig + array[0].plaHig;
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].advOth + array[0].majOth + array[0].opeOth + array[0].plaOth;
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].advSta + array[0].majSta + array[0].opeSta + array[0].plaSta;
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].advNon + array[0].majNon + array[0].opeNon + array[0].plaNon;

					array[0].basTotH = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotH = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].advTotH = array[0].advBus + array[0].advHig + array[0].advOth + array[0].advSta + array[0].advNon;
					array[0].majTotH = array[0].majBus + array[0].majHig + array[0].majOth + array[0].majSta + array[0].majNon;
					array[0].opeTotH = array[0].opeBus + array[0].opeHig + array[0].opeOth + array[0].opeSta + array[0].opeNon;
					array[0].plaTotH = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;

					// Total H
					array[0].totTotH = array[0].basTotH + array[0].appTotH + array[0].advTotH + array[0].majTotH + array[0].opeTotH + array[0].plaTotH;

					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotH;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotH;
					array[0].advTot = array[0].advFed + array[0].advFun + array[0].advTotH;
					array[0].majTot = array[0].majFed + array[0].majFun + array[0].majTotH;
					array[0].opeTot = array[0].opeFed + array[0].opeFun + array[0].opeTotH;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotH;
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].advTot + array[0].majTot + array[0].opeTot + array[0].plaTot;
				} if (qId === "10") {
					// a
					array[0].totFed = array[0].basFed + array[0].appFed + array[0].advFed + array[0].majFed + array[0].opeFed + array[0].plaFed;
					// b
					array[0].totFun = array[0].basFun + array[0].appFun + array[0].advFun + array[0].majFun + array[0].opeFun + array[0].plaFun;
					// c
					array[0].totBus = array[0].basBus + array[0].appBus + array[0].advBus + array[0].majBus + array[0].opeBus + array[0].plaBus;
					// d
					array[0].totHig = array[0].basHig + array[0].appHig + array[0].advHig + array[0].majHig + array[0].opeHig + array[0].plaHig;
					// e
					array[0].totOth = array[0].basOth + array[0].appOth + array[0].advOth + array[0].majOth + array[0].opeOth + array[0].plaOth;
					// f
					array[0].totSta = array[0].basSta + array[0].appSta + array[0].advSta + array[0].majSta + array[0].opeSta + array[0].plaSta;
					// g
					array[0].totNon = array[0].basNon + array[0].appNon + array[0].advNon + array[0].majNon + array[0].opeNon + array[0].plaNon;

					array[0].basTotH = array[0].basBus + array[0].basHig + array[0].basOth + array[0].basSta + array[0].basNon;
					array[0].appTotH = array[0].appBus + array[0].appHig + array[0].appOth + array[0].appSta + array[0].appNon;
					array[0].advTotH = array[0].advBus + array[0].advHig + array[0].advOth + array[0].advSta + array[0].advNon;
					array[0].majTotH = array[0].majBus + array[0].majHig + array[0].majOth + array[0].majSta + array[0].majNon;
					array[0].opeTotH = array[0].opeBus + array[0].opeHig + array[0].opeOth + array[0].opeSta + array[0].opeNon;
					array[0].plaTotH = array[0].plaBus + array[0].plaHig + array[0].plaOth + array[0].plaSta + array[0].plaNon;

					// h
					array[0].totTotH = array[0].basTotH + array[0].appTotH + array[0].advTotH + array[0].majTotH + array[0].opeTotH + array[0].plaTotH;

					array[0].basTot = array[0].basFed + array[0].basFun + array[0].basTotH;
					array[0].appTot = array[0].appFed + array[0].appFun + array[0].appTotH;
					array[0].advTot = array[0].advFed + array[0].advFun + array[0].advTotH;
					array[0].majTot = array[0].majFed + array[0].majFun + array[0].majTotH;
					array[0].opeTot = array[0].opeFed + array[0].opeFun + array[0].opeTotH;
					array[0].plaTot = array[0].plaFed + array[0].plaFun + array[0].plaTotH;

					// i
					array[0].totTot = array[0].basTot + array[0].appTot + array[0].advTot + array[0].majTot + array[0].opeTot + array[0].plaTot;
				} if (qId === "11") {
					array[0].totCon = array[0].conCon + array[0].plaCon;
					array[0].totGra = array[0].conGra + array[0].plaGra;

					array[0].conTot = array[0].conCon + array[0].conGra;
					array[0].plaTot = array[0].plaCon + array[0].plaGra;
					array[0].totTot = array[0].conTot + array[0].plaTot;
				} if (qId === "12") {
					// 1. Mapping of index → federalagencyid
					const agencyMap = [
						"000007", "000008", "000047", "000018", "000019", "000021", "000035", "000045",
						"000046", "000010", "000011", "000012", "000013", "000020", "000015", "000016",
						"000017", "000023", "000022", "000024", "000048", "000003", "000004", "000006",
						"000025", "000027", "000030", "000031", "000033", "000034", "000049", "000043",
						"000037", "000038", "000039", "000040", "000036", "000042"
					];
					// 2. Compute totals + assign IDs for rows 0–37
					array.forEach((row, idx) => {
						row.tot = row.con + row.pla;
						const id = agencyMap[idx];
						if (id) row.federalagencyid = id;
					});
					// 3. Explanation validation (same logic you had)
					if (array[37].tot !== 0 && expval === "") {
						document.getElementById("span_Id").innerText =
							"Please enter explanation for Other department/agency, If incase not entered.";
					} else {
						document.getElementById("span_Id").innerText = "";
					}
					// 4. Compute grand totals (exclude the last row "000042")
					let con = 0;
					let pla = 0;
					for (const row of array) {
						if (row.federalagencyid !== "000042") {
							con += row.con;
							pla += row.pla;
						}
					}
					// 5. Write totals into the last row (index 37)
					const totalRow = array[37];
					totalRow.con = con;
					totalRow.pla = pla;
					totalRow.tot = con + pla;
					totalRow.federalagencyid = "000042";
				} if (qId === "13" || qId === "14" || qId === "15") {
					array[0].tot = array[0].fed + array[0].ffr + array[0].bus + array[0].edu + array[0].oth + array[0].sta;
					array[0].stateId = "10061";
					array[1].tot = array[1].fed + array[1].ffr + array[1].bus + array[1].edu + array[1].oth + array[1].sta;
					array[1].stateId = "11091";
					array[2].tot = array[2].fed + array[2].ffr + array[2].bus + array[2].edu + array[2].oth + array[2].sta;
					array[2].stateId = "12081";
					array[3].tot = array[3].fed + array[3].ffr + array[3].bus + array[3].edu + array[3].oth + array[3].sta;
					array[3].stateId = "13071";
					array[4].tot = array[4].fed + array[4].ffr + array[4].bus + array[4].edu + array[4].oth + array[4].sta;
					array[4].stateId = "14092";
					array[5].tot = array[5].fed + array[5].ffr + array[5].bus + array[5].edu + array[5].oth + array[5].sta;
					array[5].stateId = "15082";
					array[6].tot = array[6].fed + array[6].ffr + array[6].bus + array[6].edu + array[6].oth + array[6].sta;
					array[6].stateId = "16011";
					array[7].tot = array[7].fed + array[7].ffr + array[7].bus + array[7].edu + array[7].oth + array[7].sta;
					array[7].stateId = "17051";
					array[8].tot = array[8].fed + array[8].ffr + array[8].bus + array[8].edu + array[8].oth + array[8].sta;
					array[8].stateId = "18052";
					array[9].tot = array[9].fed + array[9].ffr + array[9].bus + array[9].edu + array[9].oth + array[9].sta;
					array[9].stateId = "19053";
					array[10].tot = array[10].fed + array[10].ffr + array[10].bus + array[10].edu + array[10].oth + array[10].sta;
					array[10].stateId = "20054";
					array[11].tot = array[11].fed + array[11].ffr + array[11].bus + array[11].edu + array[11].oth + array[11].sta;
					array[11].stateId = "21093";
					array[12].tot = array[12].fed + array[12].ffr + array[12].bus + array[12].edu + array[12].oth + array[12].sta;
					array[12].stateId = "22083";
					array[13].tot = array[13].fed + array[13].ffr + array[13].bus + array[13].edu + array[13].oth + array[13].sta;
					array[13].stateId = "23031";
					array[14].tot = array[14].fed + array[14].ffr + array[14].bus + array[14].edu + array[14].oth + array[14].sta;
					array[14].stateId = "24032";
					array[15].tot = array[15].fed + array[15].ffr + array[15].bus + array[15].edu + array[15].oth + array[15].sta;
					array[15].stateId = "25041";
					array[16].tot = array[16].fed + array[16].ffr + array[16].bus + array[16].edu + array[16].oth + array[16].sta;
					array[16].stateId = "26042";
					array[17].tot = array[17].fed + array[17].ffr + array[17].bus + array[17].edu + array[17].oth + array[17].sta;
					array[17].stateId = "27062";
					array[18].tot = array[18].fed + array[18].ffr + array[18].bus + array[18].edu + array[18].oth + array[18].sta;
					array[18].stateId = "28072";
					array[19].tot = array[19].fed + array[19].ffr + array[19].bus + array[19].edu + array[19].oth + array[19].sta;
					array[19].stateId = "29012";
					array[20].tot = array[20].fed + array[20].ffr + array[20].bus + array[20].edu + array[20].oth + array[20].sta;
					array[20].stateId = "30055";
					array[21].tot = array[21].fed + array[21].ffr + array[21].bus + array[21].edu + array[21].oth + array[21].sta;
					array[21].stateId = "31013";
					array[22].tot = array[22].fed + array[22].ffr + array[22].bus + array[22].edu + array[22].oth + array[22].sta;
					array[22].stateId = "32033";
					array[23].tot = array[23].fed + array[23].ffr + array[23].bus + array[23].edu + array[23].oth + array[23].sta;
					array[23].stateId = "33043";
					array[24].tot = array[24].fed + array[24].ffr + array[24].bus + array[24].edu + array[24].oth + array[24].sta;
					array[24].stateId = "34063";
					array[25].tot = array[25].fed + array[25].ffr + array[25].bus + array[25].edu + array[25].oth + array[25].sta;
					array[25].stateId = "35044";
					array[26].tot = array[26].fed + array[26].ffr + array[26].bus + array[26].edu + array[26].oth + array[26].sta;
					array[26].stateId = "36084";
					array[27].tot = array[27].fed + array[27].ffr + array[27].bus + array[27].edu + array[27].oth + array[27].sta;
					array[27].stateId = "37045";
					array[28].tot = array[28].fed + array[28].ffr + array[28].bus + array[28].edu + array[28].oth + array[28].sta;
					array[28].stateId = "38085";
					array[29].tot = array[29].fed + array[29].ffr + array[29].bus + array[29].edu + array[29].oth + array[29].sta;
					array[29].stateId = "39014";
					array[30].tot = array[30].fed + array[30].ffr + array[30].bus + array[30].edu + array[30].oth + array[30].sta;
					array[30].stateId = "40021";
					array[31].tot = array[31].fed + array[31].ffr + array[31].bus + array[31].edu + array[31].oth + array[31].sta;
					array[31].stateId = "41086";
					array[32].tot = array[32].fed + array[32].ffr + array[32].bus + array[32].edu + array[32].oth + array[32].sta;
					array[32].stateId = "42022";
					array[33].tot = array[33].fed + array[33].ffr + array[33].bus + array[33].edu + array[33].oth + array[33].sta;
					array[33].stateId = "43056";
					array[34].tot = array[34].fed + array[34].ffr + array[34].bus + array[34].edu + array[34].oth + array[34].sta;
					array[34].stateId = "44046";
					array[35].tot = array[35].fed + array[35].ffr + array[35].bus + array[35].edu + array[35].oth + array[35].sta;
					array[35].stateId = "45034";
					array[36].tot = array[36].fed + array[36].ffr + array[36].bus + array[36].edu + array[36].oth + array[36].sta;
					array[36].stateId = "46073";
					array[37].tot = array[37].fed + array[37].ffr + array[37].bus + array[37].edu + array[37].oth + array[37].sta;
					array[37].stateId = "47094";
					array[38].tot = array[38].fed + array[38].ffr + array[38].bus + array[38].edu + array[38].oth + array[38].sta;
					array[38].stateId = "48023";
					array[39].tot = array[39].fed + array[39].ffr + array[39].bus + array[39].edu + array[39].oth + array[39].sta;
					array[39].stateId = "49015";
					array[40].tot = array[40].fed + array[40].ffr + array[40].bus + array[40].edu + array[40].oth + array[40].sta;
					array[40].stateId = "50057";
					array[41].tot = array[41].fed + array[41].ffr + array[41].bus + array[41].edu + array[41].oth + array[41].sta;
					array[41].stateId = "51047";
					array[42].tot = array[42].fed + array[42].ffr + array[42].bus + array[42].edu + array[42].oth + array[42].sta;
					array[42].stateId = "52064";
					array[43].tot = array[43].fed + array[43].ffr + array[43].bus + array[43].edu + array[43].oth + array[43].sta;
					array[43].stateId = "53074";
					array[44].tot = array[44].fed + array[44].ffr + array[44].bus + array[44].edu + array[44].oth + array[44].sta;
					array[44].stateId = "54087";
					array[45].tot = array[45].fed + array[45].ffr + array[45].bus + array[45].edu + array[45].oth + array[45].sta;
					array[45].stateId = "55016";
					array[46].tot = array[46].fed + array[46].ffr + array[46].bus + array[46].edu + array[46].oth + array[46].sta;
					array[46].stateId = "56058";
					array[47].tot = array[47].fed + array[47].ffr + array[47].bus + array[47].edu + array[47].oth + array[47].sta;
					array[47].stateId = "57095";
					array[48].tot = array[48].fed + array[48].ffr + array[48].bus + array[48].edu + array[48].oth + array[48].sta;
					array[48].stateId = "58059";
					array[49].tot = array[49].fed + array[49].ffr + array[49].bus + array[49].edu + array[49].oth + array[49].sta;
					array[49].stateId = "59035";
					array[50].tot = array[50].fed + array[50].ffr + array[50].bus + array[50].edu + array[50].oth + array[50].sta;
					array[50].stateId = "60088";
					for (var i = 0; i < array.length; i++) {
						if (array[i].stateId == 70000) {
							array[51].tot = array[51].fed + array[51].ffr + array[51].bus + array[51].edu + array[51].oth + array[51].sta;
							array[51].stateId = "70000";
						}
						if (array[i].stateId == 70001) {
							array[52].tot = array[52].fed + array[52].ffr + array[52].bus + array[52].edu + array[52].oth + array[52].sta;
							array[52].stateId = "70001";
						}
						if (array[i].stateId == 70002) {
							array[53].tot = array[53].fed + array[53].ffr + array[53].bus + array[53].edu + array[53].oth + array[53].sta;
							array[53].stateId = "70002";
						}
						if (array[i].stateId == 64100) {
							array[54].tot = array[54].fed + array[54].ffr + array[54].bus + array[54].edu + array[54].oth + array[54].sta;
							array[54].stateId = "64100";
						}
						if (array[i].stateId == 70003) {
							array[55].tot = array[55].fed + array[55].ffr + array[55].bus + array[55].edu + array[55].oth + array[55].sta;
							array[55].stateId = "70003";
						}
						if (array[i].stateId == 65100) {
							array[56].tot = array[56].fed + array[56].ffr + array[56].bus + array[56].edu + array[56].oth + array[56].sta;
							array[56].stateId = "65100";
						}
						if (array[i].stateId == 62200) {
							array[57].tot = array[57].fed + array[57].ffr + array[57].bus + array[57].edu + array[57].oth + array[57].sta;
							array[57].stateId = "62200";
						}
						if (array[i].stateId == 81000) {
							array[58].tot = array[58].fed + array[58].ffr + array[58].bus + array[58].edu + array[58].oth + array[58].sta;
							array[58].stateId = "81000";
						}
					}
					fed = 0;
					ffr = 0;
					bus = 0;
					edu = 0;
					oth = 0;
					sta = 0;
					for (var k = 0; k < array.length; k++) {
						if (array[k].stateId != 91000) {
							fed += array[k].fed;
							ffr += array[k].ffr;
							bus += array[k].bus;
							edu += array[k].edu;
							oth += array[k].oth;
							sta += array[k].sta;
						}
					}
					array[59].fed = fed;
					array[59].ffr = ffr;
					array[59].bus = bus;
					array[59].edu = edu;
					array[59].oth = oth;
					array[59].sta = sta;
					// TOTAL
					array[59].tot = array[59].fed + array[59].ffr + array[59].bus + array[59].edu + array[59].oth + array[59].sta;
					array[59].stateId = "91000";
				}
				// ===============================
				// qId 18 & 19 — FFRDC / UARC
				// ===============================
				if (qId === "18" || qId === "19") {
					const ffrdcIds = [
						"930042", "920011", "920012", "930803", "930013", "930074", "930100", "930075", "930038", "930073",
						"931100", "920064", "910002", "920031", "930905", "930904", "910005", "920024", "920016", "910012",
						"920010", "910011", "930903", "920027", "931110", "930801", "920030", "930066", "930047", "923900",
						"923888", "930004", "930885", "920020", "930065", "910009", "910010", "930900", "920017", "920804",
						"930041", "920066", "940000"
					];
					const uarcIds = [
						"1", "16", "2", "3", "4", "5", "6", "7", "8", "9",
						"10", "11", "12", "13", "14", "15"
					];
					let bas = 0; let app = 0; let adv = 0; let maj = 0; let ope = 0; let pla = 0;
					array.forEach((row, i) => {
						const isLast = (i === array.length - 1);
						// Compute totals for all but last row
						if (!isLast) {
							row.tot = row.bas + row.app + row.adv + row.maj + row.ope + row.pla;
							bas += row.bas;
							app += row.app;
							adv += row.adv;
							maj += row.maj;
							ope += row.ope;
							pla += row.pla;
						}
						// qId 18 → FFRDC
						if (qId === "18") {
							if (i < ffrdcIds.length) row.ffrdcId = ffrdcIds[i];

							// Reset row 42
							if (i === 42) {
								row.tot = row.bas + row.app + row.adv + row.maj + row.ope + row.pla;
								row.ffrdcId = "940000";
							}
						}
						// qId 19 → UARC
						if (qId === "19") {
							if (i < uarcIds.length) row.uarcid = uarcIds[i];

							// Reset row 15
							if (i === 15) {
								row.bas = bas;
								row.app = app;
								row.adv = adv;
								row.maj = maj;
								row.ope = ope;
								row.pla = pla;
								row.tot = row.bas + row.app + row.adv + row.maj + row.ope + row.pla;
								row.uarcid = "15";
							}
						}
					});
				}
				// ===============================
				// qId 20 — Research totals
				// ===============================
				if (qId === "20") {
					let res = 0; let adv = 0; let maj = 0; let ope = 0; let pla = 0; let sefel = 0; let fac = 0; let oth = 0;
					// Sum all non-total rows
					for (const row of array) {
						if (row.orgCod !== "000001") {
							res += row.res;
							adv += row.adv;
							maj += row.maj;
							ope += row.ope;
							pla += row.pla;
							sefel += row.seFel;
							fac += row.fac;
							oth += row.oth;
						}
					}

					// Write into total row
					const totalRow = array.find(r => r.orgCod === "000001");
					if (totalRow) {
						totalRow.res = res;
						totalRow.adv = adv;
						totalRow.maj = maj;
						totalRow.ope = ope;
						totalRow.pla = pla;
						totalRow.seFel = sefel;
						totalRow.fac = fac;
						totalRow.oth = oth;
					}
				}
				// ===============================
				// qId 21 — Research totals (subset)
				// ===============================
				if (qId === "21") {
					let res = 0; let adv = 0; let maj = 0; let ope = 0; let pla = 0;
					// Sum all non-total rows
					for (const row of array) {
						if (row.orgCod !== "000001") {
							res += row.res;
							adv += row.adv;
							maj += row.maj;
							ope += row.ope;
							pla += row.pla;
						}
					}
					// Write into total row
					const totalRow = array.find(r => r.orgCod === "000001");
					if (totalRow) {
						totalRow.res = res;
						totalRow.adv = adv;
						totalRow.maj = maj;
						totalRow.ope = ope;
						totalRow.pla = pla;
					}
				}
			}
			context.commit('setIsSaving', { isSaving: true });
			await answerService.saveAnswer(qId, array, true).then(function (response) {
				if (response && CONSTANTS.HTTP.NO_CONTENT === response.status) { // 204 - Success No Content
					// Trigger loading this questions validation messages
					context.dispatch('validation/loadSurveyValidationMessages');
					// Trigger loading all question statuses
					context.dispatch('validation/loadQuestionStatuses');
					context.commit('setIsSaving', { isSaving: false });
					context.commit('setIsLoading', { isLoading: false });
					context.commit('setLastSaved', { lastSavedTimeStamp: utilityService.getTimeStamp() });
					context.commit('setquestionId', { questionId: qId });
				}
			})
			.catch(function (e) {
				context.commit('setIsSaving', { isSaving: false });
				context.commit('setIsLoading', { isLoading: false });
				if (!isStandardSurvey && qId === 11) {
					context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try saving Queston 1 then try again saving Question 11, may resolve the problem' });
				} else if (qId === 10) {
					context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try saving Queston 9 then try again saving Question 10, may resolve the problem' });
				} else {
					context.commit('setLastSaved', { lastSavedTimeStamp: 'An error occured, Please try again. "Save / Home / Close or Refresh or Clear the cache from the brower " may resolve the problem' });
				}
				console.error(e);
				throw e;
			});
		}
	},
	getters: {
		answersArray: (state) => {
			return state.answers;
		},
		isSaving: (state) => {
			return state.isSaving;
		},
		lastSavedTimeStamp: (state) => {
			return state.lastSavedTimeStamp;
		},
		count: (state) => {
			return state.count;
		},
		isLoading: (state) => {
			return state.isLoading;
		},
		isSurveyType: (state) => {
			return state.standardSurvey;
		},
		questionId: (state) => {
			return state.questionId;
		}
	}
}
export default new Vuex.Store({
	modules: {
		survey: survey,
		validation: validation
	}
});
